var render, staticRenderFns
import script from "./CollapseTransition.vue?vue&type=script&lang=js"
export * from "./CollapseTransition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_babel-core@6.26.3_coffee-script@1.12.7_css-loader_itnoqaqamkyb4nqyd5m4ndadpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports